import { mapGetters, mapActions } from 'vuex'
import manuscript from '@/api/manuscript'
import { getUploadConfig } from '@/utils/upload'
// import zip from '@/utils/zip'
import help from '@/utils/help'
import Loading from './loading.dialog'
import axios from 'axios'

const columns = [
  {
    title: '',
    enTitle: 'Order',
    width: 50,
    dataIndex: 'index',
    slot: 'index'
  },
  {
    title: '',
    enTitle: 'File Name',
    width: 230,
    dataIndex: 'name',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Type',
    width: 210,
    dataIndex: 'itemCode',
    slot: 'type'
  },
  {
    title: '',
    enTitle: 'Description',
    width: 320,
    dataIndex: 'description',
    slot: 'description'
  },
  {
    title: '',
    enTitle: 'Size',
    width: 80,
    dataIndex: 'size',
    slot: 'size'
  },
  {
    title: '',
    enTitle: 'Last Modified',
    width: 120,
    dataIndex: 'lastTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 150,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: { Loading },
  data() {
    return {
      columns,
      dataSource: [],
      fileTypes: {},
      ftype: [],
      hasUploadFiles: [],
      params: {},
      requiredTypes: [],
      uploadProgress: {
        current1: 0,
        current2: 0,
        current3: 0,
        current4: 0,
        current5: 0,
        current6: 0,
        current7: 0,
        current8: 0,
        current9: 0
      },
      loading: false,
      errArr: [],
      precent: 0,
      source: null
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      user: 'getUser',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      manuscript: 'getManuscript'
    })
  },
  watch: {
    manuscript: {
      handler(val) {
        if (val.id) {
          let { fileList, version, sign, id } = val
          this.params = {
            version,
            sign,
            id
          }
          fileList = fileList || []
          fileList.forEach(item => {
            if (this.fileTypes[item.itemCode]) {
              this.fileTypes[item.itemCode].file = item
            }
          })
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getTypes()
  },
  methods: {
    ...mapActions(['updateManuscript']),
    async submit() {
      let flag = false

      for (let key in this.fileTypes) {
        if (this.fileTypes[key].required && !this.fileTypes[key].file) {
          flag = true
        }
      }

      if (flag) {
        this.$message.error({
          title: 'Error',
          content: `You have to upload at least 2 types of documents, including Cover Letter, Manuscript.`
        })
        return
      }

      const path = `publisher/${this.publisherId}/manuscript/${
        this.manuscript.id
      }/submit/${help.guid()}`

      this.params.fileList = []
      // let total = 0
      for (let key in this.fileTypes) {
        // total++
        if (this.fileTypes[key].file) {
          this.params.fileList.push(this.fileTypes[key].file)
        }
      }

      const pro_all = []
      this.loading = true
      const allFiles = [] // 接口获取的需上传的文件列表
      const hasFiles = []

      for (let key in this.fileTypes) {
        allFiles.push(key)
        this.uploadProgress = Object.assign(this.uploadProgress)
        if (this.fileTypes[key].file) {
          hasFiles.push(this.fileTypes[key])
        }
      }

      this.hasUploadFiles = hasFiles
      hasFiles &&
        hasFiles.map((key, index) => {
          if (key.file && key.file.file && !key.file.file.path) {
            pro_all[index] = getUploadConfig(
              key.file.file,
              path,
              '',
              this.source.token,
              e => {
                this.ftype.map((item, index) => {
                  if (item.typeName == key.typeName) {
                    switch (item.typeName) {
                      case 'Cover Letter':
                        this.uploadProgress.current1 = e
                        break
                      case 'Manuscript (Word/ZIP)':
                        this.uploadProgress.current2 = e
                        break
                      case 'Manuscript (PDF Version)':
                        this.uploadProgress.current3 = e
                        break
                      case 'Graphical Abstract':
                        this.uploadProgress.current4 = e
                        break
                      case 'Supplementary Material':
                        this.uploadProgress.current5 = e
                        break
                      case 'Figure(s)':
                        this.uploadProgress.current6 = e
                        break
                      case 'Table(s)':
                        this.uploadProgress.current7 = e
                        break
                      case 'Dataset(s)':
                        this.uploadProgress.current8 = e
                        break
                      case 'Video(s)':
                        this.uploadProgress.current9 = e

                        break
                      default:
                        break
                    }
                  }
                })

                // } else if (index == 1) {
                //   this.uploadProgress1.current = e
                // }
              }
            ).then(res => {
              if (res && !res.includes('err:')) {
                // this.uploadProgress.current++
              }
              return res
            })

            key.index = index
          } else {
            // this.uploadProgress.current++
          }
        })

      const reses = await Promise.all(pro_all)
      this.errArr = []
      reses.forEach(item => {
        if (item && item.includes('err:')) {
          this.errArr.push(item.split(':')[1])
        }
      })

      for (let key in this.fileTypes) {
        if (
          !this.fileTypes[key].file.path &&
          reses[this.fileTypes[key].index] &&
          !reses[this.fileTypes[key].index].includes('err:')
        ) {
          this.fileTypes[key].file.path = reses[this.fileTypes[key].index]
        }
      }

      if (this.errArr.length) {
        this.$message.error(this.LANGUAGE[this.language].uploadFileFail, 5)
        this.uploadProgress = {
          current: 0,
          total: 0
        }
        return
      }
      this.loading = false

      // const pro_all = this.dataSource.map(item => {
      //   return getUploadConfig(item, path)
      // })
      // const reses = await Promise.all(pro_all)
      // const f = reses.some(item => {
      //   if (item.includes('err:')) {
      //     this.$message.error({
      //       title: 'Error',
      //       content: this.LANGUAGE[this.language].uploadFileFail
      //     })
      //     return true
      //   }
      // })
      // if (f) {
      //   return false
      // }

      const res = await manuscript.step3(this.params)

      this.updateManuscript(res)
      this.$router.push('step4?id=' + res.id)
    },
    async getTypes() {
      const fileTypes = {}
      const types = await manuscript.ftype()
      types.forEach(item => {
        item.file = ''
        fileTypes[item.id] = item
      })
      this.ftype = types
      this.fileTypes = fileTypes
      if (this.manuscript.fileList && this.manuscript.fileList.length) {
        this.manuscript.fileList.forEach(item => {
          if (this.fileTypes[item.itemCode]) {
            this.fileTypes[item.itemCode].file = item
          }
        })
      }
    },
    async handleUpload(fileType, files) {
      const types = fileType.typeFile.split('; ')
      const file = files[0]
      let type = file.name.split('.')
      type = type[type.length - 1].toLowerCase()
      this.source = axios.CancelToken.source()
      if (!types.includes(type)) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      } else {
        this.addFile(fileType, file)
      }
    },
    addFile(fileType, file) {
      const MS = 200
      let rest = MS * 1024 * 1024

      for (let item in this.fileTypes) {
        if (item.file && item.id !== fileType.id) {
          rest -= item.file.size
        }
      }

      const data = {
        name: file.name,
        typeName: fileType.typeName,
        size: file.size,
        itemCode: fileType.id,
        description: '',
        path: '',
        file: file,
        lastTime: this.$moment()
      }

      let flag = false
      if (rest - file.size < 0) {
        flag = true
      } else {
        this.fileTypes[fileType.id].file = data
      }

      if (flag) {
        this.$message.error({
          title: 'Error',
          content:
            'Files can only be uploaded up to 200M, please compress and upload again'
        })
      }
    },
    async download(file) {
      // const file = this.dataSource[index]
      // if (file) {
      const url = file.path
        ? this.domain + '/' + file.path
        : window.URL.createObjectURL(file.file)
      help.download(url, file.name)
      // } else {
      //   this.dataSource.forEach(item => {
      //     item.downloadUrl = this.domain + '/' + item.path
      //   })
      //   const newFile = await zip.zipFile(this.dataSource, 'author_files')
      //   help.download(window.URL.createObjectURL(newFile), 'author_files.zip')
      // }
    },
    del(item) {
      this.$confirm({
        title: 'Are you sure you want to delete this file?',
        content:
          'Please be aware of once this file is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        this.fileTypes[item.id].file = ''
        this.$message.success({
          title: 'Success',
          content: 'This file has been deleted!'
        })
      })
    },
    cancel() {
      this.loading = false
      location.reload()
      // this.source.cancel('Operation canceled by the user.')

      // this.uploadProgress = {}
    }
  }
}
